import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingIcon from "../../assets/LoadingIcon";
import PrimaryButton from "../../components/button/PrimaryButton";
import {
  getSuperAdminTenant,
  updateSuperAdminTenant,
} from "../../services/superadmin-tenants";

const TenantEdit = () => {
  const { tenantCode } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadTenant = async () => {
      setLoading(true);
      try {
        const response = await getSuperAdminTenant(tenantCode);
        setName(response.name ?? "");
        setActive(response.active ?? true);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    loadTenant();
  }, [tenantCode]);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      await updateSuperAdminTenant(tenantCode, { name, active });
      navigate(`/su/admin/tenants/${tenantCode}`, { replace: true });
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <LoadingIcon />;

  return (
    <div className="bg-white rounded shadow p-6">
      <h1 className="uppercase text-xl font-bold text-slate-700 mb-6">
        Edit Tenant
      </h1>
      {error ? (
        <div className="bg-errorBg text-errorText text-sm p-4 mb-6 border-errorBorder border-[0.5px] rounded-sm">
          {error}
        </div>
      ) : null}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block uppercase text-slate-600 text-xs font-bold mb-2">
            Tenant Name
          </label>
          <input
            type="text"
            aria-label="Tenant Name"
            className="border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-neutral-light rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <label className="flex items-center gap-2 mt-7 text-sm font-semibold text-slate-600">
          <input
            type="checkbox"
            checked={active}
            onChange={(e) => setActive(e.target.checked)}
          />
          Active
        </label>
      </div>
      <div className="flex justify-end mt-8">
        <PrimaryButton title="Save Tenant" onClick={handleSave} isBusy={saving} />
      </div>
    </div>
  );
};

export default TenantEdit;
